export const getScoreColor = (score: number): string => {
  const colorRange = [
    { score: 0, color: "#F04438" },
    { score: 50, color: "#F79009" },
    { score: 100, color: "#12B76A" },
  ];

  // Handle scores outside the given range
  if (score <= colorRange[0].score) {
    return colorRange[0].color;
  }

  if (score >= colorRange[colorRange.length - 1].score) {
    return colorRange[colorRange.length - 1].color;
  }

  // Find the two closest ranges
  let closestRange = colorRange[0];
  let nextRange = colorRange[1];
  for (let i = 1; i < colorRange.length; i++) {
    if (score >= colorRange[i].score) {
      closestRange = colorRange[i];
      nextRange = colorRange[i + 1];
    }
  }

  // Calculate the proportion between the two ranges
  const proportion =
    (score - closestRange.score) / (nextRange.score - closestRange.score);

  // Interpolate the color values based on the proportion
  const r = Math.round(
    parseInt(closestRange.color.slice(1, 3), 16) * (1 - proportion) +
      parseInt(nextRange.color.slice(1, 3), 16) * proportion,
  );
  const g = Math.round(
    parseInt(closestRange.color.slice(3, 5), 16) * (1 - proportion) +
      parseInt(nextRange.color.slice(3, 5), 16) * proportion,
  );
  const b = Math.round(
    parseInt(closestRange.color.slice(5, 7), 16) * (1 - proportion) +
      parseInt(nextRange.color.slice(5, 7), 16) * proportion,
  );

  // Convert the interpolated RGB values to hex format
  const interpolatedColor = `#${r.toString(16).padStart(2, "0")}${g
    .toString(16)
    .padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;

  return interpolatedColor;
};

export const getScoreText = (score: number): string => {
  if (score <= 40) {
    return "Low";
  }
  if (score <= 60) {
    return "Average";
  }
  if (score <= 75) {
    return "Good";
  }
  return "Excellent";
};
